import { SafeJSON } from './../../shared/safe-json';
import { Parent } from './../juvenile-case-sections/parent';
import { OtherAllegation } from './../juvenile-case-sections/other-allegations';

export class DispositionUndisciplined {
    private json: any;
    private caseIssueId: string;
    // private dispositionDate:string;
    private parentArray: Parent[] = [];
    private otherAllegations: any = [];

    private isOrderDispositionUndisciplinedFlagPresent = false;


    constructor(json: any, caseIssueId: string) {
        this.json = json;
        this.caseIssueId = caseIssueId;
        // this.dispositionDate = dispositionDate;
        this.populateParents();
        // this.populateDispositionDelinquent();
        this.populateOtherAllegations();
    }

    populateParents() {
        let obj: any = SafeJSON.get('partyDisplayBean', this.json);
        let index = '0';
        for (const parent of obj) {
            let value = new Parent(parent, index);
            this.parentArray.push(value);
        }
    }

    getParents(): any {
        this.parentArray.sort(function (parent1, parent2) {
            return parent1.getPartyName() === parent2.getPartyName() ? 0 : parent1.getPartyName() < parent2.getPartyName() ? -1 : 1;
        });
        return this.parentArray;
    }

    populateOtherAllegations() {
        let obj: any = SafeJSON.get('allegations', this.json);
        for (const otherAllegation of obj) {
            let allegationId: string = SafeJSON.get('allegationId', otherAllegation);
            if (allegationId !== this.caseIssueId) {
                let value = new OtherAllegation(otherAllegation);
                this.otherAllegations.push(value);
            }
        }
    }


    getOtherAllegations(): any[] {
        return this.otherAllegations;
    }

    /*Disposition Undisciplined*/
    getDispositionDate(): string {
        return SafeJSON.get('jaaDispositionDate', this.json);
    }

    getDateOfFiling(): string {
        return SafeJSON.get('jaaDateOfFiling', this.json);
    }

    getPartyName(): string {
        return SafeJSON.get('partyName', this.json);
    }

    getRelationship(): string {
        return SafeJSON.get('relationship', this.json);
    }

    getFactsNotes(): string {
        return SafeJSON.get('factsNotes', this.json);
    }

    getProtectiveSupervisionInd(): string {
        let supnIndex: string = SafeJSON.get('protectiveSupervisionInd', this.json);

        if (supnIndex !== undefined || supnIndex.trim() !== '') {
            return 'NE'; // Not Exist
        }
        return supnIndex;
    }

    getSupervisionPeriod(): string {
        return SafeJSON.get('supervisionPeriod', this.json);
    }

    getGoodBehaviorInd(): string {
        return SafeJSON.get('goodBehaviorInd', this.json);
    }

    getAttendSchoolInd(): string {
        return SafeJSON.get('attendSchoolInd', this.json);
    }

    getMaintainGradesInd(): string {
        return SafeJSON.get('maintainGradesInd', this.json);
    }

    getNumberCourses(): string {
        return SafeJSON.get('numberCourses', this.json);
    }

    getNotAssociateInd(): string {
        return SafeJSON.get('notAssociateInd', this.json);
    }

    getNotAssociateNotes(): string {
        return SafeJSON.get('notAssociateNotes', this.json);
    }

    getNotInPlacesInd(): string {
        return SafeJSON.get('notInPlacesInd', this.json);
    }

    getNotInPlacesNotes(): string {
        return SafeJSON.get('notInPlacesNotes', this.json);
    }

    getAbideCurfewInd(): string {
        return SafeJSON.get('abideCurfewInd', this.json);
    }

    getAbideCurfewNotes(): string {
        return SafeJSON.get('abideCurfewNotes', this.json);
    }

    getReportToCounselorInd(): string {
        return SafeJSON.get('reportToCounselorInd', this.json);
    }

    getEmployedRegularlyInd(): string {
        return SafeJSON.get('employedRegularlyInd', this.json);
    }

    getOtherInd(): string {
        return SafeJSON.get('otherInd', this.json);
    }

    getOtherNotes(): string {
        return SafeJSON.get('otherNotes', this.json);
    }

    getContinuanceInd(): string {
        return SafeJSON.get('continuanceInd', this.json);
    }

    getContinuancePeriod(): string {
        return SafeJSON.get('continuancePeriod', this.json);
    }

    getContinuancePlan(): string {
        return SafeJSON.get('continuancePlan', this.json);
    }

    getExpertExamInd(): string {
        return SafeJSON.get('expertExamInd', this.json);
    }

    getExpertName(): string {
        return SafeJSON.get('expertName', this.json);
    }

    getExpertHearingDate(): string {
        return SafeJSON.get('expertHearingDate', this.json);
    }

    getInterdisciplineEvalInd(): string {
        return SafeJSON.get('interdisciplineEvalInd', this.json);
    }

    getInHomeSupervisionInd(): string {
        return SafeJSON.get('inHomeSupervisionInd', this.json);
    }

    getSupervisedBy(): string {
        return SafeJSON.get('supervisedBy', this.json);
    }

    getSupervisionConditions(): string {
        return SafeJSON.get('supervisionConditions', this.json);
    }

    getChangeOfCustodyInd(): string {
        return SafeJSON.get('changeOfCustodyInd', this.json);
    }

    getMotherCustodyInd(): string {
        return SafeJSON.get('motherCustodyInd', this.json);
    }

    getMothersName(): string {
        return SafeJSON.get('mothersName', this.json);
    }

    getFatherCustodyInd(): string {
        return SafeJSON.get('fatherCustodyInd', this.json);
    }

    getFathersName(): string {
        return SafeJSON.get('fathersName', this.json);
    }

    getOtherCustodyInd(): string {
        return SafeJSON.get('otherCustodyInd', this.json);
    }

    getOtherName(): string {
        return SafeJSON.get('otherName', this.json);
    }

    getCountyCustodyInd(): string {
        return SafeJSON.get('countyCustodyInd', this.json);
    }

    getCountyName(): string {
        return SafeJSON.get('countyName', this.json);
    }

    getExcuseFromSchoolInd(): string {
        return SafeJSON.get('excuseFromSchoolInd', this.json);
    }

    getPlanNotes(): string {
        return SafeJSON.get('planNotes', this.json);
    }

    getParentRequirementsInd(): string {
        return SafeJSON.get('parentRequirementsInd', this.json);
    }

    getMotherComplyInd(): string {
        return SafeJSON.get('motherComplyInd', this.json);
    }

    getFatherComplyInd(): string {
        return SafeJSON.get('fatherComplyInd', this.json);
    }

    getGuardianComplyInd(): string {
        return SafeJSON.get('guardianComplyInd', this.json);
    }

    getCustodianComplyInd(): string {
        return SafeJSON.get('custodianComplyInd', this.json);
    }

    getOtherOrderInd(): string {
        return SafeJSON.get('otherOrderInd', this.json);
    }

    getOtherOrderNotes(): string {
        return SafeJSON.get('otherOrderNotes', this.json);
    }

    isOrderDetailsPresent(): string {
        let flag = 'E'; // Empty
        // tslint:disable-next-line:max-line-length
        if ((this.getContinuanceInd() !== 'OFF') || (this.getContinuanceInd().trim() !== '') || (this.getContinuancePeriod().trim() !== '') || (this.getContinuancePlan().trim() !== '') ||
            (this.getExpertExamInd() !== 'OFF') || (this.getExpertExamInd().trim() !== '') || (this.getExpertName().trim() !== '') || (this.getExpertHearingDate().trim() !== '') ||
            // tslint:disable-next-line:max-line-length
            (this.getInterdisciplineEvalInd() !== 'OFF') || (this.getInterdisciplineEvalInd().trim() !== '') || (this.getInHomeSupervisionInd() !== 'OFF') ||
            (this.getInHomeSupervisionInd().trim() !== '') || (this.getSupervisedBy().trim() !== '') || (this.getSupervisionConditions().trim() !== '') || (this.getChangeOfCustodyInd() !== 'OFF') ||
            // tslint:disable-next-line:max-line-length
            (this.getChangeOfCustodyInd().trim() !== '') || (this.getMotherCustodyInd() !== 'OFF') || (this.getMotherCustodyInd().trim() !== '') ||
            (this.getMothersName().trim() !== '') || (this.getFatherCustodyInd() !== 'OFF') || (this.getFatherCustodyInd().trim() !== '') ||
            (this.getFathersName().trim() !== '') || (this.getOtherCustodyInd() !== 'OFF') || (this.getOtherCustodyInd().trim() !== '') ||
            // tslint:disable-next-line:max-line-length
            (this.getOtherName().trim() !== '') || (this.getCountyCustodyInd() !== 'OFF') || (this.getCountyCustodyInd().trim() !== '') || (this.getCountyName().trim() !== '') ||
            (this.getExcuseFromSchoolInd() !== 'OFF') || (this.getExcuseFromSchoolInd().trim() !== '') || (this.getPlanNotes().trim() !== '') ||
            // tslint:disable-next-line:max-line-length
            (this.getParentRequirementsInd() !== 'OFF') || (this.getParentRequirementsInd().trim() !== '') || (this.getMotherComplyInd() !== 'OFF') ||
            (this.getMotherComplyInd().trim() !== '') || (this.getFatherComplyInd() !== 'OFF') || (this.getFatherComplyInd().trim() !== '') ||
            // tslint:disable-next-line:max-line-length
            (this.getGuardianComplyInd() !== 'OFF') || (this.getGuardianComplyInd().trim() !== '') || (this.getCustodianComplyInd() !== 'OFF') ||
            (this.getCustodianComplyInd().trim() !== '') || (this.getOtherOrderInd() !== 'OFF') || (this.getOtherOrderInd().trim() !== '') || (this.getOtherOrderNotes().trim() !== '')) {
            flag = 'NE'; // NOT Empty
        }
        return flag;

    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/disposition-undisciplined.ts